import React from "react";
import "./SuccessDialog.css";
import { FaCheckCircle, FaTimes } from "react-icons/fa";

const SuccessDialog = ({ open, application, onClose }) => {

    if (!open) return null;

    return (

        <div className="success-dialog-overlay">

            <div className="success-dialog">

                <button
                    className="success-close-btn"
                    onClick={onClose}
                >
                    <FaTimes />
                </button>

                <div className="success-icon">

                    <FaCheckCircle />

                </div>

                <h2>

                    Application Submitted

                </h2>

                <p className="success-subtitle">

                    Thank you for applying for an internship at
                    <span> HORYZEN TECHNOLOGIES</span>

                </p>

                <div className="success-info">

                    <div className="success-row">

                        <span>Application ID</span>

                        <strong>{application.applicationId}</strong>

                    </div>

                    <div className="success-row">

                        <span>Applicant</span>

                        <strong>{application.fullName}</strong>

                    </div>

                    <div className="success-row">

                        <span>Internship Domain</span>

                        <strong>{application.domain}</strong>

                    </div>

                    <div className="success-row">

                        <span>Registered Email</span>

                        <strong>{application.email}</strong>

                    </div>

                </div>

                <div className="success-message">

                    <FaCheckCircle />

                    <p>

                        A confirmation email has been sent successfully.

                        <br />

                        Our recruitment team will review your application.

                        <br />

                        You will receive further updates via email.

                    </p>

                </div>

                <button
                    className="success-btn"
                    onClick={onClose}
                >

                    Close

                </button>

            </div>

        </div>

    );

};

export default SuccessDialog;